import { create } from 'zustand';

export interface AuthUser {
  _id: string;
  email: string;
  name: string;
  role: 'admin' | 'viewer';
  active: boolean;
  lastLoginAt: string | null;
  createdAt: string;
  updatedAt: string;
}

interface AuthState {
  accessToken: string | null;
  user: AuthUser | null;
  isBootstrapping: boolean;
  setAuth: (token: string, user: AuthUser) => void;
  clearAuth: () => void;
  setBootstrapping: (b: boolean) => void;
}

export const useAuthStore = create<AuthState>((set) => ({
  accessToken: null,
  user: null,
  isBootstrapping: true,
  setAuth: (token, user) => set({ accessToken: token, user }),
  clearAuth: () => set({ accessToken: null, user: null }),
  setBootstrapping: (b) => set({ isBootstrapping: b }),
}));
